import React, { useMemo } from "react";
import styles from "./MainTitle.module.css";
import {
  selectSelectedGroupValues,
  selectSelectedGroupTypeValue,
  selectCommittedAllGroupEntities,
  selectModeValue,
} from "state/selections/selectors";
import {
  selectDisplayMajorsAndMinorsOnTitle
} from 'state/app/selectors'
import SelectionState from "state/selections/SelectionState";
import { useSelector } from "react-redux";
import { isDefined } from "@ls/js-utils";
import { selectFetchingEntities } from "state/data/selectors";
import {
  selectSelectedEntities,
} from "state/selections/selectors";

import { ClipLoader } from "react-spinners";
import { selectIsDrawerOpen } from "state/app/selectors";
import Mode from "state/selections/Mode";

export const reduction = (values) => {
  return values.reduce((acc, curr) => {
    const { id } = curr;
    return { ...acc, [id]: curr };
  }, {});
};
const MainTitle = (props) => {
  const selectedGroupValues = useSelector(
    selectSelectedGroupValues(SelectionState.COMMITTED)
  );
  const selectedGroupTypeValue = useSelector(
    selectSelectedGroupTypeValue(SelectionState.COMMITTED)
  );
  const displayMajorMinorOnTitle = useSelector(
    selectDisplayMajorsAndMinorsOnTitle
  );

  const fetchingEntities = useSelector(selectFetchingEntities);
  const isDrawerOpen = useSelector(selectIsDrawerOpen);
  const groupTypeGroups = useSelector(selectCommittedAllGroupEntities);
  const selectedEntities = useSelector(
    selectSelectedEntities(SelectionState.COMMITTED)
  );
  const groupLabel = useMemo(() => {
    if (!isDefined(selectedGroupValues)) {
      return null;
    }
    switch (selectedGroupTypeValue) {
      case "CUSTOM":
        return selectedGroupValues.map((groupId) => {
          return reduction(groupTypeGroups)[groupId]?.description;
        });
      case "PRODUCT":
        return selectedGroupValues.map((groupId) => {
          return reduction(groupTypeGroups)[groupId]?.description;
        });
      case "INVEST_PLATFORM":
        return selectedGroupValues.map((groupId) => {
          return reduction(groupTypeGroups)[groupId]?.desc;
        });
      case "CLIENT_PORTFOLIO_MANAGER":
        return selectedGroupValues.map((groupId) => {
          return reduction(groupTypeGroups)[groupId]?.lastName;
        });
      case "MANAGER":
        return selectedGroupValues.map((groupId) => {
          return reduction(groupTypeGroups)[groupId]?.lastName;
        });
      default:
        return null;
    }
  }, [groupTypeGroups, selectedGroupTypeValue, selectedGroupValues]);

  const groupTypeLabel = useMemo(() => {
    if (!isDefined(selectedGroupTypeValue)) {
      return null;
    }
    return selectedGroupTypeValue;
  }, [selectedGroupTypeValue]);



  const getTopbarEntityNames = (displayMajorAndMinorOnTitle) => {

    let noOfEntities = selectedEntities.length

   // if (noOfEntities > 1) {
      //  let displayNamesOfAllEntites = selectedEntities.map(entity => (entity?.minor ? ` (${entity?.major || ''}/${entity?.minor})` : ` (${entity?.major}/)`))
      //let displayNamesOfAllEntites = selectedEntities.map((entity, index) => entity?.label)
      let displayNamesOfAllEntites = displayMajorAndMinorOnTitle ? selectedEntities.map((entity, index) => entity?.label) 
                                                                 : selectedEntities.map((entity, index) => entity?.name)
      if (noOfEntities < 10) {
        return displayNamesOfAllEntites.join(" ,  " ?? [])
      } else {
        return displayNamesOfAllEntites.slice(0, 9).concat([" ..."])
          .join(" , " ?? [])
      }
    }
    //return selectedEntities.map(entity => entity?.label).join(", " ?? [])
 // }

  const mode = useSelector(selectModeValue(SelectionState.COMMITTED));

  return (
    <div className={styles.root}>
      {!isDrawerOpen && fetchingEntities && (
        <>
          <div className={styles.spinner}>
            <ClipLoader size={28} color={"#ffffff"} />
          </div>
          <div className={styles.mask} />
        </>
      )}
      {mode === Mode.ACC_GROUPS && (
        <div>
          <div className={styles.firstLabel}>
            <span>{groupLabel?.join(", " ?? [])}</span>
          </div>
          {groupTypeLabel && (
            <div className={styles.firstLabel}>
              <span className={styles.vs}>-</span>
              {groupTypeLabel}
            </div>
          )}
        </div>
      )}
      {
        mode === Mode.ENTITIES &&  (
          <div className={styles.secondLabel}>

            <span>
              {
                getTopbarEntityNames(displayMajorMinorOnTitle)
              }
            </span>
          </div>
        )
      }
    </div>
  );
};


export default MainTitle;
